import {
    NAVBAR_LINK_ABOUT_US,
    NAVBAR_LINK_CONTACT_US,
    NAVBAR_LINK_CREDIT_REPAIR,
    NAVBAR_LINK_HOME,
    NAVBAR_LINK_LOGIN,
    NAVBAR_LINK_INSURANCE,
    NAVBAR_LINK_IMMIGRATION,
    NAVBAR_LINK_SIGNUP,
    NAVBAR_LINK_SUPPORT,
    NAVBAR_LINK_TAXES,
    NAVBAR_LINK_TRAVEL,
    NAVBAR_LINK_NOTARY,
    NAVBAR_SERVICE_DESC_CREDIT,
    NAVBAR_SERVICE_DESC_TAXES,
    NAVBAR_SERVICE_DESC_IMMIGRATION,
    NAVBAR_SERVICE_DESC_INSURANCE,
    NAVBAR_SERVICE_DESC_TRAVEL,
    NAVBAR_SERVICE_DESC_NOTARY,
} from "../../../locales/types"
import AccountingFF from "../../coroinside-icon/AccountingFF"
import CreditScoreFF from "../../coroinside-icon/CreditScoreFF"
import RelaxFF from "../../coroinside-icon/RelaxFF"
import { FiFeather, FiGlobe, FiShield } from "react-icons/fi"


// Office phone is sourced from REACT_APP_BUSINESS_PHONE_OFFICE so every CTA
// (header, footer, forms, JSON-LD, legal) stays in sync with one env value.
const OFFICE_DIGITS = (process.env.REACT_APP_BUSINESS_PHONE_OFFICE || '').replace(/\D/g, '');
const OFFICE_E164 = OFFICE_DIGITS.length === 10 ? `1${OFFICE_DIGITS}` : OFFICE_DIGITS;
const formatUsPhone = (d) => {
    if (d.length === 10) return `+1 (${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
    if (d.length === 11) return `+${d[0]} (${d.slice(1, 4)}) ${d.slice(4, 7)}-${d.slice(7)}`;
    return d;
};
const OFFICE_PHONE_DISPLAY = formatUsPhone(OFFICE_DIGITS);

const SUPPORT_EMAIL = process.env.REACT_APP_BUSINESS_EMAIL_SUPPORT || 'support@linaresprocorp.com';

// Centralized contact info — reused by CTA buttons, footer and forms.
export const CONTACT_INFO = {
    phone: OFFICE_PHONE_DISPLAY,
    phoneHref: `tel:+${OFFICE_E164}`,
    whatsappHref: `https://wa.me/${OFFICE_E164}`,
    email: SUPPORT_EMAIL,
    emailHref: `mailto:${SUPPORT_EMAIL}`,
    address: {
        line1: '6001 NW 153rd St',
        line2: 'Miami Lakes, FL 33014',
        mapHref: 'https://maps.google.com/?q=6001+NW+153rd+St,+Miami+Lakes,+FL+33014',
    },
    social: {
        instagram: 'https://www.instagram.com/linaresprocorp/',
        facebook: 'https://www.facebook.com/linaresprocorp',
    },
}


export const navbarButtons = [
    {
        title: 'Home',
        trans: NAVBAR_LINK_HOME,
        href: '/',
    },
]

export const navbarRightLinks = [
    {
        title: 'About',
        trans: NAVBAR_LINK_ABOUT_US,
        href: '/about',
    },
    {
        title: 'Support',
        trans: NAVBAR_LINK_SUPPORT,
        href: '/support',
    },
    {
        title: 'Contact',
        trans: NAVBAR_LINK_CONTACT_US,
        href: '/support#contact',
    },
]


export const services = [
    {
        title: 'Immigration',
        trans: NAVBAR_LINK_IMMIGRATION,
        description: NAVBAR_SERVICE_DESC_IMMIGRATION,
        href: '/immigration',
        icon: FiGlobe,
        accent: 'primary',
    },
    {
        title: 'Taxes',
        trans: NAVBAR_LINK_TAXES,
        description: NAVBAR_SERVICE_DESC_TAXES,
        href: '/taxes',
        icon: AccountingFF,
        accent: 'secondary',
    },
    {
        title: 'Insurance',
        trans: NAVBAR_LINK_INSURANCE,
        description: NAVBAR_SERVICE_DESC_INSURANCE,
        href: '/insurance',
        icon: FiShield,
        accent: 'primary',
    },
    {
        title: 'CreditRepair',
        trans: NAVBAR_LINK_CREDIT_REPAIR,
        description: NAVBAR_SERVICE_DESC_CREDIT,
        href: '/credit_repair',
        icon: CreditScoreFF,
        accent: 'secondary',
    },
    {
        title: 'Travel',
        trans: NAVBAR_LINK_TRAVEL,
        description: NAVBAR_SERVICE_DESC_TRAVEL,
        href: '/travel',
        icon: RelaxFF,
        accent: 'primary',
    },
    {
        title: 'Notary',
        trans: NAVBAR_LINK_NOTARY,
        description: NAVBAR_SERVICE_DESC_NOTARY,
        href: '/notary',
        icon: FiFeather,
        accent: 'secondary',
    },
]


export const guestLinks = [
    {
        title: 'Log in',
        trans: NAVBAR_LINK_LOGIN,
        href: '/login',
    },
    {
        title: 'Signup',
        trans: NAVBAR_LINK_SIGNUP,
        href: '/registration',
    },
]

export const authenticatedLinks = []

